__turbopack_context__.v({
  "cell": "cardsGrid-module__3kCq9W__cell",
  "grid": "cardsGrid-module__3kCq9W__grid",
  "type1up": "cardsGrid-module__3kCq9W__type1up",
  "type1up100vh": "cardsGrid-module__3kCq9W__type1up100vh",
  "type2up": "cardsGrid-module__3kCq9W__type2up",
  "type2up40_60": "cardsGrid-module__3kCq9W__type2up40_60",
  "type2up60_40": "cardsGrid-module__3kCq9W__type2up60_40",
  "type4up": "cardsGrid-module__3kCq9W__type4up",
  "typeDefault": "cardsGrid-module__3kCq9W__typeDefault",
});
